import { useEffect, useState } from 'react';

import { mapBridge, MAP_MAX_PITCH } from './mapBridge';

export function PitchSlider() {
  const [pitch, setPitch] = useState(0);

  useEffect(() => mapBridge.subscribePitch(setPitch), []);

  const applyPitch = (sliderValue: number) => {
    mapBridge.setPitchTarget(MAP_MAX_PITCH - sliderValue, false);
  };

  const sliderValue = MAP_MAX_PITCH - pitch;

  return (
    <div
      className="flex h-[6.75rem] w-11 min-w-11 flex-col items-center justify-between rounded-lg bg-bg-panel/90 px-1.5 py-2 shadow ring-1 ring-bg-border backdrop-blur sm:h-[6.25rem]"
      title={`Tilt ${Math.round(pitch)}°`}
    >
      <span className="pointer-events-none shrink-0 select-none font-mono text-xs font-semibold tabular-nums leading-none text-slate-400" aria-hidden>
        0°
      </span>
      <div className="pitch-slider-shell flex w-full flex-1 items-center justify-center py-1">
        <input
          type="range"
          className="pitch-slider"
          min={0}
          max={MAP_MAX_PITCH}
          step={1}
          value={sliderValue}
          onChange={(e) => applyPitch(Number(e.target.value))}
          onInput={(e) => applyPitch(Number((e.target as HTMLInputElement).value))}
          aria-label="Map pitch"
          aria-valuemin={0}
          aria-valuemax={MAP_MAX_PITCH}
          aria-valuenow={Math.round(pitch)}
          aria-valuetext={`${Math.round(pitch)} degrees${pitch >= MAP_MAX_PITCH - 0.5 ? ', maximum tilt' : pitch < 1 ? ', top-down' : ''}`}
        />
      </div>
      <span className="pointer-events-none shrink-0 select-none font-mono text-xs font-semibold tabular-nums leading-none text-slate-400" aria-hidden>
        {MAP_MAX_PITCH}°
      </span>
    </div>
  );
}
